import { useEffect, useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router';
import { ApiError } from '../api/client';
import { useAuth } from '../auth/auth-context';

export function LoginPage() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  // 이미 로그인된 상태로 /login에 들어오면 대시보드로 보낸다.
  useEffect(() => {
    if (user) navigate('/', { replace: true });
  }, [user, navigate]);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(username, password);
      navigate('/', { replace: true });
    } catch (err) {
      const msg =
        err instanceof ApiError && err.status === 401
          ? '아이디 또는 비밀번호가 잘못됐습니다.'
          : (err as Error).message;
      setError(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <form className="card login-card" onSubmit={handleSubmit}>
        <h2 style={{ marginTop: 0 }}>로그인</h2>
        {error && (
          <div className="banner error" data-testid="login-error">
            {error}
          </div>
        )}
        <div style={{ display: 'grid', gap: '0.75rem' }}>
          <label>
            아이디
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
              autoComplete="username"
              required
              data-testid="login-username"
              style={{ width: '100%', marginTop: 4 }}
            />
          </label>
          <label>
            비밀번호
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              data-testid="login-password"
              style={{ width: '100%', marginTop: 4 }}
            />
          </label>
          <button
            className="btn"
            type="submit"
            disabled={busy}
            data-testid="login-submit"
          >
            {busy ? '로그인 중…' : '로그인'}
          </button>
        </div>
      </form>
    </div>
  );
}
